/* src/app/shared/mat-msg-dlg/mat-msg-dlg.component.css */
.mat-dlg-close {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  width: 100%;
}
/*# sourceMappingURL=mat-msg-dlg.component.css.map */
